import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';
import customerSupportOperationsFactory from './customerSupportOperations';
import merchantEntitlementsFactory from './merchantEntitlements';
import partnerAppsFactory from './partnerApps';
import preferencesFactory from './preferences';
import serviceProviderBillingFactory from './serviceProviderBilling';
import serviceProviderEntitlementsFactory from './serviceProviderEntitlements';
import usersFactory from './users';

interface AdminApiReturn {
    customerSupportOperations: ReturnType<typeof customerSupportOperationsFactory>
    merchantEntitlements: ReturnType<typeof merchantEntitlementsFactory>
    partnerApps: ReturnType<typeof partnerAppsFactory>
    preferences: ReturnType<typeof preferencesFactory>
    serviceProviderBilling: ReturnType<typeof serviceProviderBillingFactory>
    serviceProviderEntitlements: ReturnType<typeof serviceProviderEntitlementsFactory>
    users: ReturnType<typeof usersFactory>
}

export default (axios: AxiosInstance = baseAxios): AdminApiReturn => ({
    customerSupportOperations: customerSupportOperationsFactory(axios),
    merchantEntitlements: merchantEntitlementsFactory(axios),
    partnerApps: partnerAppsFactory(axios),
    preferences: preferencesFactory(axios),
    serviceProviderBilling: serviceProviderBillingFactory(axios),
    serviceProviderEntitlements: serviceProviderEntitlementsFactory(axios),
    users: usersFactory(axios),
});
